export default "__VITE_ASSET__35u5QN_O__"